/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { createEmptyStateResource, createErrorStateResource, createStateResource } from '../resource/resource.util';
import { LoadResourceFailureProps, LoadResourceSuccessProps, SingleResourceLoadActions } from './actions';
import { initialResourceState, SingleResourceState } from './state.model';

export class SingleResourceReducer {
  public reducer: ActionReducer<SingleResourceState, Action>;

  constructor(private readonly actions: SingleResourceLoadActions) {
    this.initReducer();
  }

  initReducer(): void {
    this.reducer = createReducer(
      initialResourceState,
      on(
        this.actions.loadAction,
        (state: SingleResourceState): SingleResourceState => ({
          ...state,
          resource: { ...state.resource, loading: true },
        }),
      ),
      on(
        this.actions.loadSuccessAction,
        (state: SingleResourceState, props: LoadResourceSuccessProps): SingleResourceState => ({
          ...state,
          resource: createStateResource(props.resource),
        }),
      ),
      on(
        this.actions.loadFailureAction,
        (state: SingleResourceState, props: LoadResourceFailureProps): SingleResourceState => ({
          ...state,
          resource: createErrorStateResource(props.error),
        }),
      ),
      on(
        this.actions.clearAction,
        (state: SingleResourceState): SingleResourceState => ({
          ...state,
          resource: createEmptyStateResource(),
        }),
      ),
      on(
        this.actions.reloadAction,
        (state: SingleResourceState): SingleResourceState => ({
          ...state,
          resource: { ...state.resource, reload: true },
        }),
      ),
    );
  }
}
